<template>
  <div
    class="min-w-[196px] grid grid-cols-[repeat(auto-fill,22px)] gap-2 w-full cursor-default m-0 px-3 py-2.5"
  >
    <ColorItem
      v-for="(item, index) in colors"
      :key="item"
      :color-value="item"
      :color-name="index"
      :selected-color="currentColor"
      @clickEvent="onChangeTheme(index)"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue';
import ColorItem from './ColorItem.vue';

const colors = ref({
  default: '#616a6b',
  orange: '#853100',
  brown: '#563400',
  gold: '#676400',
  moss: '#447702',
  green: '#00500b',
  cyan: '#007262',
  lightBlue: '#005c97',
  blue: '#0f2da7',
  purple: '#540093',
  pink: '#71004e',
  red: '#6a1800',
});

const props = defineProps({
  selectedColor: {
    type: String,
    default: null,
  },
  onChangeColor: {
    type: Function,
    default: () => {},
  },
});

const currentColor = ref(props.selectedColor);

const onChangeTheme = colorName => {
  currentColor.value = colorName;
  props.onChangeColor();
};
</script>
